<script lang="ts">
    import * as Card from "$lib/components/ui/card/index.js";
    import { cn } from "@/lib/utils";
    let className: string = undefined
    export {className as class}
</script>

<Card.Root class={cn("flex lg:min-h-[850px] rounded-b-none sm:rounded-b-xl", className)}>
    <div class="grid grid-cols-1 lg:grid-cols-[350px,1fr] flex-1">
        <div class="ml-6 my-6 bg-secondary rounded-xl relative header-background opacity-70 hidden lg:block">   
            <div class="mt-6 ml-6 font-bold text-4xl text-white">
                Discover.<br/>
                Improve.<br/>
                Perform.
            </div>
            <img class="absolute bottom-0 right-0 mr-4 mb-4 h-10" src="https://alpha.xertonline.com/assets/images/xert_teal_and_gray.png" alt="Xert Logo"/>
        </div>
        <div>
            <slot name="content"/>
        </div>
    </div>
</Card.Root>


<style lang="scss">

    .header-background {
        background: linear-gradient(0deg, rgba(var(--rgb-xert-teal), 0.80) 0%, rgba(var(--rgb-xert-teal), 0.80) 100%), url("/assets/images/xfai/Road cyclist riding through a surreal, multi-dimensional universe.webp");
        background-position: top right 33%;
    }

</style>